import React from 'react';
import { Package } from 'lucide-react';
import { Badge } from './ui/badge';

const ProductCard = ({ product }) => {
  return (
    <div className="group bg-white rounded-xl border border-slate-200 overflow-hidden hover:shadow-lg hover:border-slate-300 transition-all duration-300">
      <div className="relative h-48 overflow-hidden bg-slate-100">
        <img
          src={product.image}
          alt={product.name}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          onError={(e) => {
            e.target.style.display = 'none';
            e.target.nextSibling.style.display = 'flex';
          }}
        />
        <div className="hidden w-full h-full items-center justify-center bg-slate-100">
          <Package className="w-12 h-12 text-slate-300" />
        </div>
        <Badge className="absolute top-3 left-3 bg-slate-900 hover:bg-slate-900">
          {product.category}
        </Badge>
      </div>

      <div className="p-5">
        <h3 className="font-semibold text-slate-800 mb-2 line-clamp-2 group-hover:text-slate-900 transition-colors">
          {product.name}
        </h3>

        <div className="mt-4">
          <p className="text-xs text-slate-500 mb-1">Min. Order</p>
          <p className="text-sm font-medium text-slate-700">{product.minOrder} units</p>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
